import { render, staticRenderFns } from "./TaxCategoryListTable.vue?vue&type=template&id=4bd12b60&"
import script from "./TaxCategoryListTable.vue?vue&type=script&lang=js&"
export * from "./TaxCategoryListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports